// extracted by mini-css-extract-plugin
export default {"container":"PropertiesAddPhotoCard_container__N5lMh","container_posting":"PropertiesAddPhotoCard_container_posting__BIMT2"};